/* eslint-disable max-len */
import LoginTranslate from '@/app/features/Customer/features/Login/translate';
import OfferTranslate from '../features/Offer/translate';
import RegisterTranslate from '@/app/features/Customer/features/Register/translate';
import CompleteRegisterTranslate from '@/app/features/Customer/features/CompleteRegister/translate';
import PaymentTranslate from '../features/Payment/translate';
import EventTranslate from '@/app/features/InteractEventTracker/translate';
import { EPaymentMethodTypes, EPaymentMethod } from '@/helpers/enums';

enum ErrorMessages {
  paymentBankSecurity = '<strong>Atenção!</strong> Sua transação foi negada por motivos de segurança do seu banco. Por favor, entre em contato com o emissor do seu cartão de crédito para verificar o motivo e tente novamente. Se estiver usando um cartão virtual, atente-se as regras de compra do seu banco. Se preferir, realize o pagamento com outro cartão de crédito.',
  paymentBankSecurityRecurrent = '<strong>Atenção!</strong> Sua transação foi negada por motivos de segurança do seu banco. Por favor, entre em contato com o emissor do seu cartão de crédito para verificar o motivo e tente novamente. Se preferir,realize o pagamento com outro cartão de crédito. Se estiver usando um cartão virtual, atente-se as regras de compra do seu banco. <b>Atenção:</b> O cartão virtual do Itaú expira a cada compra e não faz compras recorrentes.',
  paymentNoBalance = '<strong>Atenção!</strong> Transação negada pelo seu banco. Entre em contato com o emissor do seu cartão de crédito para saber mais detalhes.Se preferir, utilize outro cartão ou entre em contato com a nossa central de vendas. Nossa equipe auxiliará você sobre outras opções de pagamento.',
  paymentCardExpired = '<strong>Atenção!</strong> Sua transação foi negada pois seu cartão está vencido ou a data de vencimento foi digitada incorretamente. Verifique se os dados do seu cartão de crédito estão corretos e tente novamente. Se preferir, realize o pagamento com outro cartão de crédito.',
  paymentCardWrongCode = '<strong>Atenção!</strong> O código de segurança do seu cartão de crédito foi digitado incorretamente. Por favor, confira a informação no verso do seu cartão de crédito (ou na frente, se for Amex) e tente novamente. Se preferir, realize o pagamento com outro cartão de crédito.',
  paymentCardCreditOnly = '<strong>Atenção!</strong> Não aceitamos cartão de débito. Por favor, utilize um cartão de crédito válido  e tente novamente. Se preferir, realize o pagamento com outro cartão de crédito ou entre em contato com a nossa central de vendas. Nossa equipe auxiliará você sobre outras opções de pagamento.',
  paymentCardInstalmentNotAllowed = '<strong>Atenção!</strong> Não aceitamos cartão de débito. Por favor, utilize um cartão de crédito válido, verifque se ele possui o parcelamento liberado  e tente novamente. Se preferir, realize o pagamento com outro cartão de crédito ou entre em contato com a nossa central de vendas. Nossa equipe auxiliará você sobre outras opções de pagamento.',
  paymentCardNewBlocked = '<strong>Atenção!</strong> Seu cartão novo ainda não foi desbloqueado. Entre em contato com o emissor do seu cartão  de crédito para efetivar o desbloqueio e tente novamente. Se preferir, realize o pagamento com outro cartão de crédito.',
  paymentCardBlocked = '<strong>Atenção!</strong> Transação negada pelo seu banco. Por favor, entre em contato com o emissor do seu cartão de crédito para saber mais detalhes. Se preferir, realize o pagamento com outro cartão de crédito.',
  paymentEmitterProblem = '<strong>Atenção!</strong> Não foi possível finalizar seu pagamento. Por favor, efetue a compra novamente e, caso o erro persista, utilize outro cartão de crédito.',
  paymentPasswordProblem = '<strong>Atenção!</strong> Transação negada. Entre em contato com o banco emissor do seu cartão de crédito para saber mais detalhes. Se preferir, realize o pagamento com outro cartão de crédito.',
  paymentNumInstalmentNotAllowed = '<strong>Atenção!</strong> Sua transação não foi autorizada pois a quantidade de parcelas escolhida é maior que a permitida em seu cartão. Por favor, selecione um número de parcelas inferior e tente novamente. Se preferir, realize o pagamento com outro cartão de crédito.',
  paymentTransactionReferredByIssuer = '<strong>Atenção!</strong> Sua transação foi negada. Por favor, entre em contato com o banco emissor do seu cartão para verificar o ocorrido e tente novamente. Se preferir, utilize outro cartão ou entre em contato com a nossa central de vendas. Nossa equipe auxiliará você sobre outras opções de pagamento.',
  paymentGatewayCommunication = '<strong>Atenção!</strong> Não foi possível finalizar seu pagamento. Tente novamente dentro de alguns minutos ou entre em contato com a nossa central de vendas. Nossa equipe auxiliará você sobre outras opções de pagamento.',
  paymentCB = '<strong>Atenção!</strong> Utilize outro cartão de credito para fazer a compra ou entre em contato com a nossa central de vendas. Nossa equipe auxiliará você sobre outras opções de pagamento.',
  paymentAntiFraudLocks = '<strong>Atenção!</strong> Entre em contato com a nossa central de vendas através do número <a href="tel:4003-3117"> <b> 4003-3117 </b> </a>  (custo de ligação local). Nossa equipe auxiliará você sobre outras opções de pagamento.',
  paymentOther = '<strong>Atenção!</strong> Sua transação foi negada. Por favor, entre em contato com o banco emissor do seu cartão para verificar o ocorrido e tente novamente. Se preferir, utilize outro cartão ou entre em contato com a nossa central de vendas. Nossa equipe auxiliará você sobre outras opções de pagamento.',
  paymentInvalidCoupon = '<strong>Atenção!</strong> Este cupom já foi utilizado. Por favor, tente novamente utilizando outro cupom.',
  paymentDefault = '<strong>Atenção!</strong> Sua transação foi negada. Por favor, entre em contato com o banco emissor do seu cartão para verificar o ocorrido e tente novamente. Se preferir, utilize outro cartão ou entre em contato com a nossa central de vendas. Nossa equipe auxiliará você sobre outras opções de pagamento.',
}

export default {
  pt_BR: {
    Login: LoginTranslate.pt_BR,
    Offer: OfferTranslate.pt_BR,
    Register: RegisterTranslate.pt_BR,
    CompleteRegister: CompleteRegisterTranslate.pt_BR,
    Payment: PaymentTranslate.pt_BR,
    EventTracker: EventTranslate.pt_BR,
    Steps: {
      step: 'Passo',
      steps: {
        1: 'Identificação',
        2: 'Pagamento',
        3: 'Compra realizada',
        4: 'Renovação realizada',
      }
    },
    Renew: 'Ao concluir este pedido de renovação você garante o acesso ao conteúdo da sua assinatura {interval}.',
    Renewal: 'Renovação',
    Error: 'Erro',
    GenericErrorDescription: 'Não foi possivel recuperar oferta',
    plan: 'Plano',
    intervalType: {
      days: 'Diário',
      weeks: 'Semanal',
      months: 'Mensal',
      trimesters: 'Trimestral',
      semesters: 'Semestral',
      years: 'Anual',
      lifelong: 'Vitalício'
    },
    creditCardPix: {
      disclaimer: 'Seu acesso ao conteúdo será liberado após a confirmação de pagamento via cartão de crédito e pagamento do Pix. Caso o pagamento via Pix não seja realizado dentro de 30 minutos a compra será cancelada e o valor cobrado será estornado em seu cartão.',
      waitingPayment: {
        title: 'Falta pouco, agora escaneie o QR Code',
        subtitle: 'Número do {0} #{1} • {2}',
        description: '<p>Escaneie o QR Code e confirme as informações da sua compra no aplicativo da sua instituição financeira, e pronto!</p><p>Se preferir, copie o código Pix que está disponível abaixo do QR Code e cole no site ou aplicativo da sua instituição financeira para confirmar as informações da sua compra.</p><p>Em caso de dúvidas sobre o pedido, por favor entre em contato conosco.</p>',
      },
    },
    koin: {
      waitingPayment: {
        title: 'Parcelamento de boleto aprovado pela Koin',
        description: '<p>O primeiro boleto foi enviado para o seu e-mail (<span>{0}</span>). Realize o pagamento para finalizar seu pedido junto à Empiricus e acessar seus conteúdos.</p><p>Devido ao tempo de processamento, a liberação do seu pedido pode demorar até 3 dias após o pagamento do boleto.</p>',
      },
      underReview: {
        title: 'Parcelamento de boleto em análise',
        description: '<p>Em breve a Koin entrará em contato com você para confirmar alguns dados antes de aprovar sua solicitação de parcelamento de boleto.</p>',
      },
    },
    termsAndConditions: {
      checkbox: 'Quero receber ofertas e novidades das assinaturas da Empiricus e autorizo, inclusive, o uso de cookies.',
      term: 'Termos de uso',
      policy: 'Política de Privacidade',
      policyLink: 'https://www.empiricus.com.br/politica-de-privacidade/?xpromo=XE-ME-GGL-IE-X-X-SH-X-X',
      text: `<p><span>Agradecemos por escolher a </span><strong>EMPIRICUS RESEARCH PUBLICA&Ccedil;&Otilde;ES LTDA</strong><span>.
      </span><a target="_blank" href="https://www.empiricus.com.br/?xpromo=XE-ME-GGL-IE-X-X-SH-X-X"><span>(&ldquo;</span><strong>EMPIRICUS</strong>
      <span>&rdquo;)</span></a><span>. Ao assinar quaisquer de nossos produtos, Voc&ecirc; concorda e sujeita-se a estes </span>
      <a target="_blank" href="https://www.empiricus.com.br/termos-de-uso/?xpromo=XE-ME-GGL-IE-X-X-SH-X-X"><span>&ldquo;Termos de Uso&rdquo;</span></a>
      <span> e &agrave; </span>
      <a target="_blank" href="https://www.empiricus.com.br/politica-de-privacidade/?xpromo=XE-ME-GGL-IE-X-X-SH-X-X">
      <span>&ldquo;Pol&iacute;tica de Privacidade&rdquo;</span></a><span>. Voc&ecirc; confirma que leu e compreendeu integralmente
      ambos os documentos, aceitando cumpri-los. Caso n&atilde;o concorde com referidos instrumentos, n&atilde;o poder&aacute; acessar as
      publica&ccedil;&otilde;es da
      </span><strong>EMPIRICUS</strong><span>.</span></p>    <p>
      <span>Leia atentamente os Termos de Uso, eles abrangem informa&ccedil;&otilde;es relevantes sobre as
      publica&ccedil;&otilde;es peri&oacute;dicas da </span><strong>EMPIRICUS</strong><span>, tais como (i) futuras altera&ccedil;&otilde;es
      nos Termos de Uso e na Pol&iacute;tica de Privacidade, (ii) informa&ccedil;&otilde;es de privacidade e (iii) acesso &agrave;s
      publica&ccedil;&otilde;es.</span></p>
      <p><span>A </span><strong>EMPIRICUS</strong><span> &eacute; uma empresa que se destina &agrave; produ&ccedil;&atilde;o,
      edi&ccedil;&atilde;o e publica&ccedil;&atilde;o de conte&uacute;dos informativos, gratuitos e pagos, elaborados por editores e profissionais
      independentes, sobre assuntos relacionados &agrave; fatos econ&ocirc;micos e financeiros relevantes, com o prop&oacute;sito de fomentar a
      educa&ccedil;&atilde;o financeira da pessoa f&iacute;sica, os quais s&atilde;o distribu&iacute;dos periodicamente aos seus assinantes pessoas
       f&iacute;sicas, que possuem interesse no acesso e utiliza&ccedil;&atilde;o dessas informa&ccedil;&otilde;es.</span></p>
      <p><span>Esses conte&uacute;dos s&atilde;o oferecidos ao usu&aacute;rio em diversos formatos (planos de assinaturas, titularidades de clubes,
           cursos, v&iacute;deos, dentre outros), com prazo de vig&ecirc;ncia determinado no momento da aquisi&ccedil;&atilde;o, por meio de acesso
            online de venda e acesso desses conte&uacute;dos.</span></p>
      <p><span>Os conte&uacute;dos da </span><strong>EMPIRICUS</strong><span> ser&atilde;o acessados por meio do website </span>
      <a target="_blank" href="https://publicacoes.empiricus.com.br/?xpromo=XE-ME-GGL-IE-X-X-SH-X-X">
      <span>https://publicacoes.empiricus.com.br</span></a>
      <span> ou atrav&eacute;s do aplicativo m&oacute;vel. Voc&ecirc; possui conhecimento de que a </span><strong>EMPIRICUS</strong>
      <span> n&atilde;o &eacute; respons&aacute;vel por prover a rede de dados, conex&atilde;o via internet e/ou demais instrumentos
      para navegar em nosso site.</span></p>
      <h2><strong>1. Cadastro</strong></h2>
      <p><span>Para acessar a loja da </span><strong>EMPIRICUS</strong><span>, as publica&ccedil;&otilde;es, conte&uacute;dos assinados
      e/ou cursos, Voc&ecirc; dever&aacute; efetuar um cadastro pr&eacute;vio, fornecendo informa&ccedil;&otilde;es pessoais, tais como,
      (i) nome completo, (ii) endere&ccedil;o de e-mail, (iii) n&uacute;mero do CPF, dentre outras, que dever&atilde;o ser periodicamente
      e permanentemente atualizadas por Voc&ecirc;.</span></p>
      <p><span>Voc&ecirc; confirma e concorda que suas informa&ccedil;&otilde;es cadastrais e de acesso s&atilde;o pessoais e
      intransfer&iacute;veis, sendo vedado o compartilhamento do acesso ao seu perfil.</span></p>
      <h2><strong>2. Modifica&ccedil;&otilde;es nos termos de uso e pol&iacute;tica de privacidade</strong></h2>
      <p><span>Esporadicamente a </span><strong>EMPIRICUS</strong><span> poder&aacute;, a seu exclusivo crit&eacute;rio, efetuar
      modifica&ccedil;&otilde;es nos presentes Termos de Uso e na Pol&iacute;tica de Privacidade. Quando assim ocorrer, a </span>
      <strong>EMPIRICUS</strong><span> fornecer&aacute; um informativo acerca das altera&ccedil;&otilde;es. O acesso cont&iacute;nuo &agrave;s
      publica&ccedil;&otilde;es da </span><strong>EMPIRICUS</strong><span>, ap&oacute;s a altera&ccedil;&atilde;o dos Termos de Uso e
      Pol&iacute;tica de Privacidade, acarretar&aacute; em sua aceita&ccedil;&atilde;o t&aacute;cita.</span></p>
      <h2><strong>3. Conduta do usu&aacute;rio</strong></h2>
      <p><span>O site da </span><strong>EMPIRICUS</strong><span> permite a disponibiliza&ccedil;&atilde;o ao usu&aacute;rio, dos
      conte&uacute;dos peri&oacute;dicos por ele assinados, os quais ser&atilde;o transferidos por meio de download e/ou impress&atilde;o
      de p&aacute;gina em formato &ldquo;HTML&rdquo; contendo a publica&ccedil;&atilde;o, a depender do interesse do usu&aacute;rio.</span></p>
      <p><span>Ao utilizar o site da </span><strong>EMPIRICUS</strong><span>, o usu&aacute;rio compromete-se a:</span></p>
      <p><span>(i) n&atilde;o criar ou utilizar mais que uma &uacute;nica forma de identifica&ccedil;&atilde;o para utilizar o website,
      assim como recebimentos gratuitos e pagos;</span></p>

      <p><span>(ii) n&atilde;o utilizar identifica&ccedil;&atilde;o de um terceiro ou permitir que terceiros utilizem sua
      identifica&ccedil;&atilde;o;</span></p>
      <p><span>(iii) n&atilde;o utilizar quaisquer elementos do site para fins comerciais, publicit&aacute;rios ou qualquer
      outro que n&atilde;o represente a finalidade principal do site;</span></p>
      <p><span>(iv) n&atilde;o disfar&ccedil;ar ou ocultar o n&uacute;mero de IP (internet protocolo) que identifica sua
      conex&atilde;o &agrave; internet;</span></p>
      <p><span>(v) n&atilde;o interferir na arquitetura do site por qualquer meio ou forma t&eacute;cnica;</span></p>
      <p><span>(vi) n&atilde;o disseminar v&iacute;rus ou c&oacute;digo de computador malicioso, arquivos ou programas
      desenvolvidos para coletar dados n&atilde;o autorizados, n&atilde;o interromper, destruir ou limitar a
      funcionalidade do site;</span></p>
      <p><span>(vii) n&atilde;o burlar qualquer tecnologia usada pela </span><strong>EMPIRICUS</strong><span> ou por qualquer
      terceiro para proteger o Conte&uacute;do; e</span></p>
      <p><span>(viii) n&atilde;o remover ou alterar qualquer direito autoral, marca comercial ou outros avisos de propriedade
      intelectual contidos em/ou distribu&iacute;dos nas publica&ccedil;&otilde;es da </span><strong>EMPIRICUS</strong>
      <span>.</span></p>
      <h2><strong>4. Conte&uacute;dos e propriedade intelectual</strong></h2>
      <p><span>As informa&ccedil;&otilde;es publicadas pela </span><strong>EMPIRICUS</strong><span>, tanto nos conte&uacute;dos
      distribu&iacute;dos gratuitamente ao p&uacute;blico em geral como nos conte&uacute;dos pagos, s&atilde;o baseados em
      informa&ccedil;&otilde;es de dom&iacute;nio p&uacute;blico, ou seja, dispon&iacute;veis a qualquer pessoa, e s&atilde;o
      consideradas confi&aacute;veis na data de sua publica&ccedil;&atilde;o, tendo em vista que as opini&otilde;es expostas nos
      conte&uacute;dos s&atilde;o oriundas de julgamentos e estimativas dos editores e profissionais independentes da </span>
      <strong>EMPIRICUS</strong><span>. Posto que as opini&otilde;es nascem de julgamentos e estimativas, est&atilde;o sujeitas
      a mudan&ccedil;a.</span></p>
      <p><span>&Eacute; vedada a reprodu&ccedil;&atilde;o e distribui&ccedil;&atilde;o, no todo ou em parte, a qualquer terceiro,
      sem pr&eacute;via e expressa autoriza&ccedil;&atilde;o da </span><strong>EMPIRICUS</strong><span>, de seus conte&uacute;dos
      disponibilizados.</span></p>
      <p><span>Esses conte&uacute;dos s&atilde;o oferecidos aos leitores e assinantes da </span><strong>EMPIRICUS</strong><span>
      em diversos formatos com prazo de vig&ecirc;ncia determinado no momento da aquisi&ccedil;&atilde;o.</span></p>
      <p><span>Os conte&uacute;dos produzidos pela </span><strong>EMPIRICUS</strong><span> n&atilde;o representam oferta de
      negocia&ccedil;&atilde;o de valores mobili&aacute;rios ou outros instrumentos financeiros. As publica&ccedil;&otilde;es t&ecirc;m
      como &uacute;nico prop&oacute;sito fomentar a educa&ccedil;&atilde;o financeira da pessoa f&iacute;sica. Os assinantes e leitores
      devem, portanto, desenvolver suas pr&oacute;prias an&aacute;lises e estrat&eacute;gias.</span></p>
      <h2><strong>5. Venda de conte&uacute;dos</strong></h2>
      <p><span>A Loja </span><strong>Empiricus</strong><span>
      (</span><a target="_blank" href="https://publicacoes.empiricus.com.br/?xpromo=XE-ME-GGL-IE-X-X-SH-X-X">
      <span>https://publicacoes.empiricus.com.br</span></a><span>) &eacute; a plataforma online pela qual a </span><strong>EMPIRICUS</strong>
      <span> vende os conte&uacute;dos informativos, disponibilizados dentro do ambiente da loja (no perfil cadastrado no site), cujo
      acesso &eacute; feito pelo login e senha cadastrados pelo assinante.</span></p>
      <p><span>Ao adquirir uma das assinaturas comercializadas pela </span><strong>EMPIRICUS</strong><span> em sua loja virtual e,
      ap&oacute;s a confirma&ccedil;&atilde;o do pagamento, o assinante ter&aacute; imediato acesso aos demais conte&uacute;dos relacionados
      da s&eacute;rie por ele assinada, bem como poder&aacute; acessar os pr&oacute;ximos conte&uacute;dos informativos da s&eacute;rie,
      disponibilizados de acordo com a periodicidade das publica&ccedil;&otilde;es, atendendo-se ao prazo de vig&ecirc;ncia da assinatura.</span></p>
      <p><span>Os pre&ccedil;os dos produtos comercializados pela </span><strong>EMPIRICUS</strong><span> est&atilde;o indicados na loja virtual
      da </span><strong>EMPIRICUS</strong><span>, no pr&oacute;prio link de acesso de divulga&ccedil;&atilde;o do produto, cujo pagamento
      ser&aacute; de acordo com a modalidade escolhida pelo usu&aacute;rio no momento da compra.</span></p>
      <p><span>A </span><strong>EMPIRICUS</strong><span> se reserva no direito de praticar varia&ccedil;&otilde;es nos pre&ccedil;os das
      assinaturas, conforme prazo e instrumento de pagamento, observado o disposto na Lei Federal n&ordm; 13.455/2017.</span></p>
      <p><span>Eventuais promo&ccedil;&otilde;es e ofertas ser&atilde;o v&aacute;lidas por prazo determinado, n&atilde;o possuindo car&aacute;
      ter vinculativo caso Voc&ecirc; opte por n&atilde;o aderi-la, durante sua validade.</span></p>
      <p><span>A </span><strong>EMPIRICUS</strong><span> n&atilde;o realiza a venda de a&ccedil;&otilde;es ou ativos financeiros e
      movimenta&ccedil;&otilde;es financeiras, sendo que eventuais investimentos feitos pelo assinante n&atilde;o s&atilde;o de responsabilidade
      da </span><strong>EMPIRICUS</strong><span>.</span></p>
      <p><span>Ao contratar um plano de assinatura e/ou um curso, as notas fiscais ser&atilde;o emitidas pela </span><strong>EMPIRICUS</strong>
      <span> conforme a periodicidade dos pagamentos e contrata&ccedil;&atilde;o, podendo o prazo da emiss&atilde;o variar entre 30 (trinta) e
      45 (quarenta e cinco) dias, conforme a contrata&ccedil;&atilde;o.</span></p>
      <p><span>Voc&ecirc; poder&aacute; tirar eventuais d&uacute;vidas atrav&eacute;s de contato com a Central de Relacionamento com o Assinante.
      A </span><strong>EMPIRICUS</strong><span> n&atilde;o prestar&aacute; qualquer tipo de consultoria e/ou assessoria personalizada ao assinante.
      D&uacute;vidas e questionamentos pertinentes ser&atilde;o objeto de abordagem dentro das publica&ccedil;&otilde;es,
      broadcasts e/ou v&iacute;deos.</span></p>
      <h2><strong>6. Programa renova f&aacute;cil</strong></h2>
      <p><span>Ao t&eacute;rmino da vig&ecirc;ncia do prazo contratado da assinatura e, </span><strong>n&atilde;o havendo manifesta&ccedil;&atilde;o
      em sentido contr&aacute;rio em at&eacute; 15 (quinze) dias antes do vencimento</strong><span>, o Plano ser&aacute; renovado automaticamente
      por igual per&iacute;odo (&ldquo;</span><span>Programa Renova F&aacute;cil</span><span>&rdquo;).</span></p>
      <p><span>VOC&Ecirc; DECLARA EXPRESSAMENTE QUE POSSUI PLENO CONHECIMENTO DE TODAS AS ESPECIFICIDADES DO PROGRAMA RENOVA F&Aacute;CIL E
      CONDI&Ccedil;&Otilde;ES DE RENOVA&Ccedil;&Atilde;O AUTOM&Aacute;TICA DO PLANO.</span></p>
      <p><span>PARA AS ASSINATURAS EXPERIMENTAIS, AO T&Eacute;RMINO DO PER&Iacute;ODO GRATUITO INFORMADO NA OFERTA, N&Atilde;O HAVENDO
      MANIFESTA&Ccedil;&Atilde;O EM CONTR&Aacute;RIO, A </span><strong>EMPIRICUS</strong><span> PODER&Aacute; COME&Ccedil;AR A COBR&Aacute;-LO
      AUTOMATICAMENTE PELA ASSINATURA DESDE A ADES&Atilde;O AO FINAL DO PER&Iacute;ODO. AO FORNECER SUAS INFORMA&Ccedil;&Otilde;ES DE PAGAMENTO,
      NO MOMENTO DO CADASTRO, VOC&Ecirc; CONCORDA COM A POSSIBILIDADE DE CONVERTER AUTOMATICAMENTE A ASSINATURA EXPERIMENTAL EM ASSINATURA PAGA,
      CASO N&Atilde;O EXTERNE SEU DESINTERESSE DENTRO DO PER&Iacute;ODO DEFINIDO NA OFERTA.</span></p>
      <p><span>Havendo mais de um cart&atilde;o de cr&eacute;dito cadastrado, visando assegurar o seu acesso cont&iacute;nuo aos Planos
      de Assinatura adquiridos, </span><strong>EMPIRICUS</strong><span> poder&aacute; efetuar a cobran&ccedil;a da renova&ccedil;&atilde;o
      autom&aacute;tica em quaisquer dos meios de pagamento indicados.</span></p>
      <p><span>O Programa Renova F&aacute;cil n&atilde;o &eacute; aplic&aacute;vel &agrave;s assinaturas vital&iacute;cias.</span></p>
      <h2><strong>7. Pol&iacute;tica de cancelamento</strong></h2>
      <p><span>A </span><strong>EMPIRICUS </strong><span>poder&aacute; comercializar seus produtos atrav&eacute;s de planos de assinatura
      mensais, semestrais, anuais, vital&iacute;cios ou com periodicidade diversa definida na oferta.</span></p>
      <p><strong>VOC&Ecirc; DECLARA EXPRESSAMENTE QUE POSSUI PLENO CONHECIMENTO DE QUE A EMPIRICUS COMERCIALIZA SEUS PRODUTOS E CURSOS </strong>
      <strong>SEM POSSIBILIDADE DE CANCELAMENTO</strong><strong>. ISTO &Eacute;, VOC&Ecirc; FICAR&Aacute; VINCULADO AO PAGAMENTO INTEGRAL DO
      PRODUTO CONTRATADO.</strong></p>
      <p><strong>Excepcionalmente</strong><span>, em ofertas e promo&ccedil;&otilde;es, a </span><strong>EMPIRICUS </strong><span>poder&aacute;
      comercializar Planos de Assinatura que comportem cancelamento. Nessa situa&ccedil;&atilde;o, a </span><strong>EMPIRICUS </strong>
      <span>informar&aacute; as condi&ccedil;&otilde;es de cancelamento da oferta</span><span> e aplicar&aacute; as seguintes regras de
      cancelamento:</span></p>
      <ol>
      <li><span>a) Os cancelamentos de assinaturas dever&atilde;o ser solicitados somente por meio de contato telef&ocirc;nico com a Central de
      Relacionamento com o Assinante.</span></li>
      <li><span>b) Para cancelamentos requeridos no prazo estabelecido no C&oacute;digo de Defesa do Consumidor (7 dias), ou, em prazo superior
      oferecido por liberalidade da </span><strong>EMPIRICUS </strong><span>(no momento da oferta), o usu&aacute;rio far&aacute; jus ao reembolso
      integral do valor pago, sendo esse per&iacute;odo considerado como prazo experimental de qualquer produto comercializado pela </span>
      <strong>EMPIRICUS</strong><span>. O reembolso integral pela </span><strong>EMPIRICUS </strong><span>do valor pago pelo assinante ser&aacute;
      realizado de acordo com a forma de pagamento escolhida no momento da compra, obedecendo-se as seguintes condi&ccedil;&otilde;es:
      (i) boleto banc&aacute;rio: o reembolso integral do valor pago pelo assinante, se dar&aacute; por dep&oacute;sito em conta banc&aacute;ria
      indicada pelo assinante; e (ii) cart&atilde;o de cr&eacute;dito: a </span><strong>EMPIRICUS </strong><span>encaminhar&aacute; &agrave;
      operadora do cart&atilde;o de cr&eacute;dito do assinante um pedido de cancelamento de compra com requerimento de estorno ao assinante de
      eventuais valores cobrados, na forma do item seguinte.</span></li>
      <li><span>c) Nos planos que admitirem o cancelamento no curso da vig&ecirc;ncia da assinatura, a solicita&ccedil;&atilde;o poder&aacute;
      ser requerida depois de (i) 7 (sete) dias da contrata&ccedil;&atilde;o ou (ii) do prazo estabelecido na oferta, contudo, n&atilde;o dar&aacute;
      direito ao reembolso integral do que foi pago, sendo objeto de estorno o valor proporcional ao per&iacute;odo utilizado e com a
      comina&ccedil;&atilde;o de multa correspondente a 20% (vinte por cento) sobre o total do plano contratado.</span></li>
      <li><span>d) No caso de cancelamento de compras feitas via cart&atilde;o de cr&eacute;dito, o estorno &eacute; solicitado pela </span>
      <strong>EMPIRICUS </strong><span>para a administradora em at&eacute; 7 (sete) dias &uacute;teis, gerando um comprovante que pode ser
      encaminhado para o assinante mediante solicita&ccedil;&atilde;o por e-mail. O estorno, ou seja, o lan&ccedil;amento a cr&eacute;dito do
      valor pago na fatura seguinte, tem prazo estimado de 30 (trinta) dias &uacute;teis para acontecer, dependendo do fechamento da fatura do
      cart&atilde;o de cr&eacute;dito do assinante, n&atilde;o se responsabilizando a </span><strong>EMPIRICUS</strong><span> por outros prazos
      estabelecidos pela operadora de cart&atilde;o de cr&eacute;dito. A responsabilidade da </span><strong>EMPIRICUS</strong><span> no processo
      de devolu&ccedil;&atilde;o em compras feitas com o cart&atilde;o de cr&eacute;dito limita-se a solicitar &agrave; administradora o estorno,
      sendo desta o dever de efetivamente realizar o cr&eacute;dito em favor do assinante na fatura do seu cart&atilde;o de cr&eacute;dito.</span>
      </li>
      <li><span>e) No caso de cancelamento de compras efetuadas por boleto banc&aacute;rio, a </span><strong>EMPIRICUS </strong><span>efetuar&aacute;
      a devolu&ccedil;&atilde;o dos valores cab&iacute;veis, por meio de dep&oacute;sito em sua conta corrente, em at&eacute; 15 (quinze)
      dias &uacute;teis do fornecimento de tais informa&ccedil;&otilde;es.</span></li>
      </ol>
      <p><span>Ao optar pelo cancelamento e/ou n&atilde;o renova&ccedil;&atilde;o do plano, o assinante perder&aacute; o acesso &agrave;s
      publica&ccedil;&otilde;es do per&iacute;odo e ao acervo disponibilizado no momento da contrata&ccedil;&atilde;o da assinatura, exceto
      das publica&ccedil;&otilde;es impressas, baixadas e/ou salvas pelo assinante.</span></p>
      <p><span>N&atilde;o ser&aacute; permitido o Cancelamento da mesma assinatura no per&iacute;odo de 3 (tr&ecirc;s) meses.</span></p>
      <p><span>Considerando o per&iacute;odo experimental concedido gratuitamente pela </span><strong>EMPIRICUS</strong><span>, somente
      ser&atilde;o admitidos 3 (tr&ecirc;s) cancelamentos por ano. O per&iacute;odo de experimental das assinaturas &eacute; limitado &agrave;
      3 (tr&ecirc;s) ades&otilde;es a cada per&iacute;odo de 12 meses.</span></p>
      <p><span>Os cancelamentos de Cursos obedecer&atilde;o &agrave;s disposi&ccedil;&otilde;es constantes no respectivo Contrato de Servi&ccedil;os
      Educacionais.</span></p>
      <h2><strong>8. Difus&atilde;o de dados de mercado</strong></h2>
      <p><span>A </span><strong>EMPIRICUS</strong><span> poder&aacute; disponibilizar e/ou retransmitir em seu s&iacute;tio eletr&ocirc;nico,
      a difus&atilde;o de dados de mercado, com atrasos, mediante acordo mantido com a B3 S/A &ndash; Brasil, Bolsa Balc&atilde;o (&ldquo;B3&rdquo;).
      Voc&ecirc;, ao aderir aos Termos de Uso e Pol&iacute;tica de Privacidade, declara estar ciente e concorda que:</span></p>
      <p><span>(i) A difus&atilde;o de dados de mercado origina-se dos sistemas de negocia&ccedil;&atilde;o por meio da tecnologia, m&eacute;todos
      e esfor&ccedil;os providos pela B3, &uacute;nica titular de todos os direitos relacionados &agrave; difus&atilde;o de dados de mercado,
      inclusive de propriedade intelectual. Voc&ecirc; se compromete a respeitar todos os direitos da B3, bem como n&atilde;o remover ou alterar
      quaisquer sinais, alertas, avisos de direito autoral ou marcas de produtos e servi&ccedil;os contidos ou mencionados na difus&atilde;o de
      dados de mercado;</span></p>
      <p><span>(ii) A mera autoriza&ccedil;&atilde;o de uso n&atilde;o confere a Voc&ecirc; nenhum direito, t&iacute;tulo, propriedade,
      participa&ccedil;&atilde;o ou qualquer prerrogativa sobre a difus&atilde;o de dados de mercado;</span></p>
      <p><span>(iii) Voc&ecirc; est&aacute; autorizado a utilizar a difus&atilde;o de dados de mercado, com a finalidade &uacute;nica e exclusiva
      de auxili&aacute;-lo, n&atilde;o sendo permitido o uso de forma contr&aacute;ria &agrave; legisla&ccedil;&atilde;o vigente ou em desacordo
      com os prop&oacute;sitos institucionais da </span><strong>EMPIRICUS</strong><span>, B3 e no acordo mantido entre estas;</span></p>
      <p><span>(iv) A utiliza&ccedil;&atilde;o dos dados de mercado difundidos, tem car&aacute;ter meramente informativo e objetiva complementar
      a experi&ecirc;ncia do Usu&aacute;rio, refor&ccedil;ando o compromisso da </span><strong>EMPIRICUS</strong><span> em prover conte&uacute;dos
      peri&oacute;dicos informativos relacionados &agrave; educa&ccedil;&atilde;o financeira, contribuindo com o aprimoramento da pessoa f&iacute;sica;
      </span></p>
      <p><span>(v) Voc&ecirc; conhece e se vincula a todas as obriga&ccedil;&otilde;es aplic&aacute;veis e estabelecidas nesta se&ccedil;&atilde;o,
      tendo conhecimento de que a </span><strong>EMPIRICUS </strong><span>poder&aacute; alter&aacute;-la, mediante solicita&ccedil;&atilde;o da B3;
      </span></p>
      <p><span>(vi) Salvo autoriza&ccedil;&atilde;o expressa da B3, n&atilde;o &eacute; permitida a utiliza&ccedil;&atilde;o da difus&atilde;o dos
      dados de mercado para fins de elabora&ccedil;&atilde;o, cria&ccedil;&atilde;o, c&aacute;lculo ou gera&ccedil;&atilde;o de qualquer modalidade
      de &iacute;ndice, sejam eles instrumentos financeiros ou valores mobili&aacute;rios em benef&iacute;cio pr&oacute;prio ou de terceiros, sob as
      penas da lei. A B3 e a </span><strong>EMPIRICUS</strong><span> poder&atilde;o tomar qualquer medida para o exerc&iacute;cio e defesa de seus
      direitos;</span></p>
      <p><span>(vii) &Eacute; expressamente vedada a distribui&ccedil;&atilde;o, redistribui&ccedil;&atilde;o, transfer&ecirc;ncia,
      transmiss&atilde;o, retransmiss&atilde;o, licen&ccedil;a, sublicen&ccedil;a, loca&ccedil;&atilde;o, empr&eacute;stimo, venda, revenda,
      circula&ccedil;&atilde;o, publica&ccedil;&atilde;o de difus&atilde;o de dados de mercado e de avalia&ccedil;&atilde;o ou fornecimento de
      bases de addos e produtos a terceiros por meio da utiliza&ccedil;&atilde;o (parcial ou integral) da difus&atilde;o de dados de mercado,
      exceto mediante autoriza&ccedil;&atilde;o da B3;</span></p>
      <p><span>(viii) A B3 e a </span><strong>EMPIRICUS</strong><span> n&atilde;o asseguram a sequ&ecirc;ncia, a pontualidade, a exatid&atilde;o
      e a integralidade da difus&atilde;o de dados de mercado, tampouco se responsabilizam, por quaisquer atrasos, inexatid&otilde;es, erros,
      omiss&otilde;es ou pelos danos decorrentes desses eventos ou por eles provocados; e</span></p>
      <p><span>(ix) Voc&ecirc; n&atilde;o poder&aacute; utilizar quaisquer marcas, s&iacute;mbolos, sinais distintivos ou elementos de
      identifica&ccedil;&atilde;o, sem o consentimento pr&eacute;vio e autorizado.</span></p>
      <h2><strong>9. Envio de SMS e WhatsApp</strong></h2>
      <p><span>Consoante as disposi&ccedil;&otilde;es da Pol&iacute;tica de Privacidade, do Contrato de Assinaturas e das especifica&ccedil;&otilde;es
      dos planos de assinatura contratados a </span><strong>EMPIRICUS </strong><span>poder&aacute;, facultativamente, encaminhar avisos,
      publica&ccedil;&otilde;es e notifica&ccedil;&otilde;es por meio de SMS (</span><em><span>short message service</span></em><span>). Muito
      embora a </span><strong>EMPIRICUS </strong><span>envide os melhores esfor&ccedil;os para assegurar o recebimento dos avisos,
      publica&ccedil;&otilde;es e notifica&ccedil;&otilde;es, em decorr&ecirc;ncia da vincula&ccedil;&atilde;o com os sistemas de telefonia,
      n&atilde;o se pode assegurar que as mensagens sejam efetivamente recebidas por Voc&ecirc;.</span></p>
      <p><span>Por essas circunst&acirc;ncias, Voc&ecirc; concorda e isenta a </span><strong>EMPIRICUS </strong><span>de toda e qualquer
      responsabilidade por falhas sist&ecirc;micas e/ou pelo n&atilde;o recebimento das mensagens enviadas.</span></p>
      <p><span>Voc&ecirc; concorda que a </span><strong>EMPIRICUS </strong><span>poder&aacute; utilizar aplicativo WhatsApp para envio de
      mensagens transacionais, incluindo alertas, textos, fotos, &aacute;udios e v&iacute;deos, para fins comerciais, institucionais e/ou
      informativos.</span></p>
      <p><span>Tanto para o envio de SMS como de mensagens pelo aplicativo WhatsApp, a </span><strong>EMPIRICUS </strong><span>utilizar&aacute;
      as informa&ccedil;&otilde;es de contato fornecidas por Voc&ecirc;, no momento do cadastro. A </span><strong>EMPIRICUS </strong>
      <span>n&atilde;o ser&aacute; respons&aacute;vel pela checagem da adequa&ccedil;&atilde;o e/ou validade de tais informa&ccedil;&otilde;es,
      de modo que, Voc&ecirc; dever&aacute; manter seus dados cadastrais permanentemente v&aacute;lidas e atualizadas.</span></p>
      <h2><strong>10. Disposi&ccedil;&otilde;es Finais</strong></h2>
      <p><span>Ao aceitar estes Termos de Uso e Pol&iacute;tica de Privacidade, o usu&aacute;rio/assinante concorda com todas as suas
      disposi&ccedil;&otilde;es, comprometendo-se a respeit&aacute;-las e n&atilde;o agir contrariamente a elas, por si e seus sucessores,
      a qualquer t&iacute;tulo, de modo irretrat&aacute;vel e irrevog&aacute;vel.</span></p>
      <p><span>Caso os Termos de Uso aqui previstos sejam desrespeitados pelo usu&aacute;rio/assinante, a </span><strong>EMPIRICUS</strong>
      <span> poder&aacute; interromper, a seu exclusivo crit&eacute;rio, o acesso do usu&aacute;rio, impossibilitando-o de realizar compras
      e acessar os conte&uacute;dos, bem como poder&aacute; cancelar compras j&aacute; realizadas e ajuizar a&ccedil;&otilde;es que forem
      necess&aacute;rias.</span></p>
      <p><span>Sem preju&iacute;zo, na hip&oacute;tese de descumprimento das obriga&ccedil;&otilde;es previstas neste termo pelo
      usu&aacute;rio/assinante, poder&aacute; a </span><strong>EMPIRICUS </strong><span>considerar rescindido o plano de assinatura contratado,
      sem direito a reembolso ao assinante.</span></p>
      <p><span>A </span><strong>EMPIRICUS</strong><span> poder&aacute; avaliar a frequ&ecirc;ncia e quantidade de seus acessos &agrave;
      (i) &aacute;rea do assinante, (ii) n&uacute;mero de downloads, (iii) impress&otilde;es de suas publica&ccedil;&otilde;es e (iv)
      visualiza&ccedil;&otilde;es dos Cursos, a fim de identificar condutas fraudulentas, de reprodu&ccedil;&atilde;o indevida ou de eventual
      compartilhamento do acesso pessoal, aplicando &agrave;s san&ccedil;&otilde;es devidas.</span></p>
      <p><span>A </span><strong>EMPIRICUS</strong><span> se reserva ao direito de alterar a qualquer tempo estes termos e condi&ccedil;&otilde;es
      que, se alterados, passam a ser v&aacute;lidos imediatamente ap&oacute;s o momento de sua publica&ccedil;&atilde;o neste site, e garante o
      respeito ao ato jur&iacute;dico perfeito.</span></p>`
    },
    availability: {
      error: {
        title: 'Não podemos seguir com a sua solicitação.',
        button: 'Ver outras opções',
        understood: 'Ver outras opções',
        code: {
          1000: 'Verificamos que esta oferta não está disponível no momento.',
          1001: 'Verificamos que esta oferta não está disponível no momento.',
          1002: 'Verificamos que esta oferta não está disponível no momento.',
          default: 'Verificamos que esta oferta não está disponível no momento.',
        },
      },
    },
    eligibility: {
      error: {
        title: 'Não podemos seguir com a sua solicitação.',
        button: 'Ir para minhas publicações',
        understood: 'Ok, entendi',
        back: 'Voltar',
        code: {
          1: 'Por favor, tente novamente ou entre em contato com o nosso atendimento.',
          1100: 'Verificamos que você já possui este conteúdo.',
          1101: 'Verificamos que você já possui este conteúdo.',
          1102: 'Verificamos que você já possui este conteúdo.',
          1103: 'Verificamos que você já possui este conteúdo.',
          1104: 'Verificamos que você já possui este conteúdo em vigência igual ou superior.',
          1200: 'Verificamos que o seu carrinho atual está inválido. ',
          1203: 'Algo deu errado. Por favor, tente novamente.',
          1204: 'Algo deu errado. Por favor, tente novamente.',
          1205: 'Algo deu errado. Por favor, tente novamente.',
          1206: 'Algo deu errado. Por favor, tente novamente.',
          1301: 'Por favor, tente novamente ou entre em contato com o nosso atendimento.',
          1302: 'Verificamos que seu acesso a esse conteúdo está inativo.',
          1303: 'Verificamos que sua assinatura não permite renovação.',
          1304: 'Verificamos que sua assinatura é vitalícia e não permite renovação.',
          1305: 'Verificamos que sua assinatura não permite renovação.',
          1306: 'Verificamos que você comprou este conteúdo recentemente.',
          1307: 'Verificamos que você renovou este conteúdo recentemente.',
          1400: '<strong>Atenção!</strong> Identificamos que em nossos sistemas esta conta pertence a uma pessoa jurídica. Entre em contato com a nossa central de vendas através do número <a href="tel:4003-3117"> (custo de ligação local). Nossa equipe te auxiliará sobre como prosseguir com sua alteração cadastral.',
          expiredLink: '<b>Importante!</b> O desconto vinculado a essa oferta expirou. Para mais detalhes entre em contato com a nossa central de relacionamento.',
          default: 'Por favor, tente novamente ou entre em contato com o nosso atendimento.',
        },
        blocked_purchase: {
          title: 'Cadastro bloqueado para compras',
          button: 'Ir para minhas publicações',
          understood: 'Ok, entendi',
          code: {
            1202: 'Caro cliente, não podemos seguir com sua compra no momento, por gentileza entre em contato com nossa central de atendimento através do número <a href="tel:4003-3117" style="color:#E83D4E!important;">4003-3118</a> (custo de uma ligação local) para seguir com o desbloqueio da sua conta.',
            default: 'Por favor, tente novamente ou entre em contato com o nosso atendimento.',
          },
        }
      },
    },
    payment: {
      error: {
        title: 'Não podemos seguir com a sua solicitação.',
        button: 'Tentar novamente',
        understood: 'Ok, entendi',
        back: 'Voltar',
        code: {
          5: ErrorMessages.paymentBankSecurity,
          FA: ErrorMessages.paymentBankSecurity,
          9999: ErrorMessages.paymentBankSecurity,
          '06': ErrorMessages.paymentBankSecurity,
          1000: ErrorMessages.paymentBankSecurity,
          1005: ErrorMessages.paymentBankSecurity,
          1009: ErrorMessages.paymentBankSecurity,
          2005: ErrorMessages.paymentBankSecurity,
          57: ErrorMessages.paymentBankSecurity,
          1019: ErrorMessages.paymentBankSecurity,
          1022: ErrorMessages.paymentBankSecurity,
          2004: ErrorMessages.paymentBankSecurity,
          2000: ErrorMessages.paymentBankSecurity,
          2007: ErrorMessages.paymentBankSecurity,
          2008: ErrorMessages.paymentBankSecurity,
          2009: ErrorMessages.paymentBankSecurity,
          1003: ErrorMessages.paymentBankSecurity,
          1007: ErrorMessages.paymentBankSecurity,
          1008: ErrorMessages.paymentBankSecurity,
          1021: ErrorMessages.paymentBankSecurity,
          1023: ErrorMessages.paymentBankSecurity,
          2003: ErrorMessages.paymentBankSecurity,
          51: ErrorMessages.paymentNoBalance,
          70: ErrorMessages.paymentNoBalance,
          1016: ErrorMessages.paymentNoBalance,
          54: ErrorMessages.paymentCardExpired,
          BV: ErrorMessages.paymentCardExpired,
          1001: ErrorMessages.paymentCardExpired,
          2001: ErrorMessages.paymentCardExpired,
          N7: ErrorMessages.paymentCardWrongCode,
          1045: ErrorMessages.paymentCardWrongCode,
          14: ErrorMessages.paymentCardCreditOnly,
          1011: ErrorMessages.paymentCardCreditOnly,
          1014: ErrorMessages.paymentCardCreditOnly,
          1042: ErrorMessages.paymentCardCreditOnly,
          1015: ErrorMessages.paymentCardCreditOnly,
          AC: ErrorMessages.paymentCardCreditOnly,
          12: ErrorMessages.paymentCardInstalmentNotAllowed,
          9102: ErrorMessages.paymentCardInstalmentNotAllowed,
          78: ErrorMessages.paymentCardNewBlocked,
          1025: ErrorMessages.paymentCardBlocked,
          '04': ErrorMessages.paymentCardBlocked,
          7: ErrorMessages.paymentCardBlocked,
          41: ErrorMessages.paymentCardBlocked,
          43: ErrorMessages.paymentCardBlocked,
          9112: ErrorMessages.paymentEmitterProblem,
          9108: ErrorMessages.paymentEmitterProblem,
          15: ErrorMessages.paymentEmitterProblem,
          9111: ErrorMessages.paymentEmitterProblem,
          98: ErrorMessages.paymentEmitterProblem,
          9109: ErrorMessages.paymentEmitterProblem,
          1017: ErrorMessages.paymentPasswordProblem,
          55: ErrorMessages.paymentPasswordProblem,
          1006: ErrorMessages.paymentPasswordProblem,
          2006: ErrorMessages.paymentPasswordProblem,
          1010: ErrorMessages.paymentPasswordProblem,
          EE: ErrorMessages.paymentNumInstalmentNotAllowed,
          1013: ErrorMessages.paymentNumInstalmentNotAllowed,
          '01': ErrorMessages.paymentTransactionReferredByIssuer,
          1002: ErrorMessages.paymentBankSecurity,
          1004: ErrorMessages.paymentBankSecurityRecurrent,
          1020: ErrorMessages.paymentBankSecurity,
          1024: ErrorMessages.paymentBankSecurity,
          2002: ErrorMessages.paymentBankSecurity,
          62: ErrorMessages.paymentBankSecurityRecurrent,
          CB: ErrorMessages.paymentCB,
          UB: ErrorMessages.paymentAntiFraudLocks,
          IPB: ErrorMessages.paymentAntiFraudLocks,
          1203: ErrorMessages.paymentInvalidCoupon,
          default: ErrorMessages.paymentDefault,
        },
      },
    },
    loading: {
      error: {
        title: 'Não podemos seguir com a sua solicitação.',
        button: 'Ver outras opções',
        code: {
          default: 'Verificamos que esta oferta não está disponível no momento.',
        },
      },
    },
    loadingTerms: {
      error: {
        title: 'Não podemos seguir com a sua solicitação.',
        button: 'Tentar novamente',
        code: {
          default: 'Por favor, tente novamente ou entre em contato com o nosso atendimento.',
        },
      },
    },
    goToMyPublications: 'Ir para minhas publicações',
    goToPayment: 'Ir para o pagamento',
    success: {
      modal: {
        title: 'Como deseja pagar?',
        sign: 'Assine',
        confirmPurchase: 'CONFIRMAR COMPRA'
      },
      instructions: {
        [EPaymentMethod.pix]: {
          title: 'Falta pouco, agora escaneie o QR Code',
          text: `
            Escaneie o QR Code e confirme as informações da sua compra no aplicativo da sua instituição financeira, e pronto!
            <br>
            Se preferir, copie o código Pix que está disponível abaixo do QR Code e cole no site ou aplicativo da sua instituição financeira para confirmar as informações da sua compra.
            <br>
            Em caso de dúvidas sobre o pedido, por favor entre em contato conosco.
          `,
          renewal: {
            title: 'Falta pouco, agora escaneie o QR Code',
            text: `
              Escaneie o QR Code e confirme as informações da sua compra no aplicativo da sua instituição financeira, e pronto!
              <br>
              Se preferir, copie o código Pix que está disponível abaixo do QR Code e cole no site ou aplicativo da sua instituição financeira para confirmar as informações da sua compra.
              <br>
              Em caso de dúvidas sobre o pedido, por favor entre em contato conosco.
            `,
          },
          upsell: {
            title: 'Falta pouco, agora escaneie o QR Code',
            text: `
              Escaneie o QR Code e confirme as informações da sua compra no aplicativo da sua instituição financeira, e pronto!
              <br>
              Se preferir, copie o código Pix que está disponível abaixo do QR Code e cole no site ou aplicativo da sua instituição financeira para confirmar as informações da sua compra.
              <br>
              Em caso de dúvidas sobre o pedido, por favor entre em contato conosco.
            `,
          },
          mobile: {
            title: 'Falta pouco, agora copie o código Pix',
            text: `
              Copie o código Pix e cole no site ou aplicativo da sua instituição financeira para confirmar as informações da sua compra, e pronto!
              <br>
              Em caso de dúvidas sobre o pedido, por favor entre em contato conosco.
            `,
            renewal: {
              title: 'Falta pouco, agora copie o código Pix',
              text: `
                Copie o código Pix e cole no site ou aplicativo da sua instituição financeira para confirmar as informações da sua compra, e pronto!
                <br>
                Em caso de dúvidas sobre o pedido, por favor entre em contato conosco.
              `,
            },
            upsell: {
              title: 'Falta pouco, agora copie o código Pix',
              text: `
                Copie o código Pix e cole no site ou aplicativo da sua instituição financeira para confirmar as informações da sua compra, e pronto!
                <br>
                Em caso de dúvidas sobre o pedido, por favor entre em contato conosco.
              `,
            },
          }
        },
        [EPaymentMethod.bankSlip]: {
          title: 'Falta pouco, agora pague o boleto da sua compra',
          text: `
            Você receberá o resumo detalhado do seu pedido juntamente com o boleto bancário por e-mail.
            <br>
            Em caso de dúvidas sobre o pedido, por favor entre em contato conosco.
          `,
          renewal: {
            title: 'Falta pouco, agora pague o boleto da sua renovação',
            text: `
              Você receberá o resumo detalhado da sua renovação juntamente com o boleto bancário por e-mail.
              <br>
              Em caso de dúvidas sobre o pedido, por favor entre em contato conosco.
            `,
          },
          upsell: {
            title: 'Falta pouco, agora pague o boleto da sua compra',
            text: `
              Você receberá o resumo detalhado do seu pedido juntamente com o boleto bancário por e-mail.
              <br>
              Em caso de dúvidas sobre o pedido, por favor entre em contato conosco.
            `,
          },
          mobile: {
            title: 'Falta pouco, agora pague o boleto da sua compra',
            text: `
              Você receberá o resumo detalhado do seu pedido juntamente com o boleto bancário por e-mail.
              <br>
              Em caso de dúvidas sobre o pedido, por favor entre em contato conosco.
            `,
            renewal: {
              title: 'Falta pouco, agora pague o boleto da sua renovação',
              text: `
                Você receberá o resumo detalhado da sua renovação juntamente com o boleto bancário por e-mail.
                <br>
                Em caso de dúvidas sobre o pedido, por favor entre em contato conosco.
              `,
            },
            upsell: {
              title: 'Falta pouco, agora pague o boleto da sua compra',
              text: `
                Você receberá o resumo detalhado do seu pedido juntamente com o boleto bancário por e-mail.
                <br>
                Em caso de dúvidas sobre o pedido, por favor entre em contato conosco.
              `,
            },
          }
        },
        [EPaymentMethod.creditCard]: {
          title: 'Obrigado, o seu pedido foi efetuado com sucesso!',
          text: `
            Você receberá o resumo detalhado da sua compra por e-mail.
            <br>
            Acesse suas publicações, o conteúdo já está disponível:
          `,
          renewal: {
            title: 'Obrigado, sua renovação foi efetuada com sucesso!',
            text: `
              Você receberá o resumo detalhado da sua renovação por e-mail.
              <br>
              Acesse suas publicações, o conteúdo já está disponível:
            `,
          },
          upsell: {
            title: 'Obrigado, o seu pedido foi efetuado com sucesso!',
            text: `
              Você receberá o resumo detalhado da sua compra por e-mail.
            `,
          },
          mobile: {
            title: 'Obrigado, o seu pedido foi efetuado com sucesso!',
            text: `
              Você receberá o resumo detalhado da sua compra por e-mail.
              <br>
              Acesse suas publicações, o conteúdo já está disponível:
            `,
            renewal: {
              title: 'Obrigado, sua renovação foi efetuada com sucesso!',
              text: `
                Você receberá o resumo detalhado da sua renovação por e-mail.
                <br>
                Acesse suas publicações, o conteúdo já está disponível:
              `,
            },
            upsell: {
              title: 'Obrigado, o seu pedido foi efetuado com sucesso!',
              text: `
                Você receberá o resumo detalhado da sua compra por e-mail.
              `,
            },
          },
        },
        [EPaymentMethod.picpay]: {
          title: 'Falta pouco, agora escaneie o QR Code',
          text: `
            Escaneie o QR Code e confirme as informações da sua compra no aplicativo do Pic Pay, e pronto!
            <br>
            Em caso de dúvidas sobre o pedido, por favor entre em contato conosco.
          `,
          renewal: {
            title: 'Falta pouco, agora escaneie o QR Code',
            text: `
              Escaneie o QR Code e confirme as informações da sua renovação no aplicativo do Pic Pay, e pronto!
              <br>
              Em caso de dúvidas sobre a renovação, por favor entre em contato conosco.
            `,
          },
          upsell: {
            title: 'Falta pouco, agora escaneie o QR Code',
            text: `
              Escaneie o QR Code e confirme as informações da sua compra no aplicativo do Pic Pay, e pronto!
              <br>
              Em caso de dúvidas sobre o pedido, por favor entre em contato conosco.
            `,
          },
          mobile: {
            title: 'Falta pouco, conclua o pagamento',
            text: `
              <a href="APP_LINK_URL" class="v-btn v-btn--block success">Realizar pagamento</a>
              <br>
              Em caso de dúvidas sobre o pedido, por favor entre em contato conosco.
            `,
            renewal: {
              title: 'Falta pouco, conclua o pagamento',
              text: `
                <a href="APP_LINK_URL" class="v-btn v-btn--block success">Realizar pagamento</a>
                <br>
                Em caso de dúvidas sobre a renovação, por favor entre em contato conosco.
              `,
            },
            upsell: {
              title: 'Falta pouco, conclua o pagamento',
              text: `
                <a href="APP_LINK_URL" class="v-btn v-btn--block success">Realizar pagamento</a>
                <br>
                Em caso de dúvidas sobre o pedido, por favor entre em contato conosco.
              `,
            },
          },
        },
        [EPaymentMethod.atarpay]: {
          title: 'Falta pouco, agora escaneie o QR Code',
          text: `
            Escaneie o QR Code e confirme as informações da sua compra no aplicativo do Atar Pay, e pronto!
            <br>
            Em caso de dúvidas sobre o pedido, por favor entre em contato conosco.
          `,
          renewal: {
            title: 'Falta pouco, agora escaneie o QR Code',
            text: `
              Escaneie o QR Code e confirme as informações da sua renovação no aplicativo do Atar Pay, e pronto!
              <br>
              Em caso de dúvidas sobre a renovação, por favor entre em contato conosco.
            `,
          },
          upsell: {
            title: 'Falta pouco, agora escaneie o QR Code',
            text: `
              Escaneie o QR Code e confirme as informações da sua compra no aplicativo do Atar Pay, e pronto!
              <br>
              Em caso de dúvidas sobre o pedido, por favor entre em contato conosco.
            `,
          },
          mobile: {
            title: 'Falta pouco, conclua o pagamento',
            text: `
              <a href="APP_LINK_URL" class="v-btn v-btn--block success">Realizar pagamento</a>
              <br>
              Em caso de dúvidas sobre o pedido, por favor entre em contato conosco.
            `,
            renewal: {
              title: 'Falta pouco, conclua o pagamento',
              text: `
                <a href="APP_LINK_URL" class="v-btn v-btn--block success">Realizar pagamento</a>
                <br>
                Em caso de dúvidas sobre a renovação, por favor entre em contato conosco.
              `,
            },
            upsell: {
              title: 'Falta pouco, conclua o pagamento',
              text: `
                <a href="APP_LINK_URL" class="v-btn v-btn--block success">Realizar pagamento</a>
                <br>
                Em caso de dúvidas sobre o pedido, por favor entre em contato conosco.
              `,
            },
          },
        },
        [EPaymentMethod.mercadopago]: {
          title: 'Falta pouco, agora escaneie o QR Code',
          text: `
            Escaneie o QR Code e confirme as informações da sua compra no aplicativo do Mercado Pago, e pronto!
            <br>
            Em caso de dúvidas sobre o pedido, por favor entre em contato conosco.
          `,
          renewal: {
            title: 'Falta pouco, agora escaneie o QR Code',
            text: `
              Escaneie o QR Code e confirme as informações da sua renovação no aplicativo do Mercado Pago, e pronto!
              <br>
              Em caso de dúvidas sobre a renovação, por favor entre em contato conosco.
            `,
          },
          upsell: {
            title: 'Falta pouco, agora escaneie o QR Code',
            text: `
              Escaneie o QR Code e confirme as informações da sua compra no aplicativo do Mercado Pago, e pronto!
              <br>
              Em caso de dúvidas sobre o pedido, por favor entre em contato conosco.
            `,
          },
          mobile: {
            title: 'Falta pouco, conclua o pagamento',
            text: `
              <a href="APP_LINK_URL" class="v-btn v-btn--block success">Realizar pagamento</a>
              <br>
              Em caso de dúvidas sobre o pedido, por favor entre em contato conosco.
            `,
            renewal: {
              title: 'Falta pouco, conclua o pagamento',
              text: `
                <a href="APP_LINK_URL" class="v-btn v-btn--block success">Realizar pagamento</a>
                <br>
                Em caso de dúvidas sobre a renovação, por favor entre em contato conosco.
              `,
            },
            upsell: {
              title: 'Falta pouco, conclua o pagamento',
              text: `
                <a href="APP_LINK_URL" class="v-btn v-btn--block success">Realizar pagamento</a>
                <br>
                Em caso de dúvidas sobre o pedido, por favor entre em contato conosco.
              `,
            },
          },
        },
        [EPaymentMethod.wireTransfer]: {
          title: 'Falta pouco, agora transfira o valor da sua compra',
          text: `
            <b> ATENÇÃO: Utilize a mesma conta informada na etapa anterior, transfira o valor exato da compra! </b>
            <br>
            Você receberá o resumo detalhado do seu pedido juntamente com os dados bancários para transferência por e-mail.
            <br>
            Em caso de dúvidas sobre o pedido, por favor entre em contato conosco.
          `,
          renewal: {
            title: 'Falta pouco, agora transfira o valor da sua compra',
            text: `
              <b> ATENÇÃO: Utilize a mesma conta informada na etapa anterior, transfira o valor exato da renovação! </b>
              <br>
              Você receberá o resumo detalhado da sua renovação juntamente com os dados bancários para transferência por e-mail.
              <br>
              Em caso de dúvidas sobre a renovação, por favor entre em contato conosco.
            `,
          },
          upsell: {
            title: 'Falta pouco, agora transfira o valor da sua compra',
            text: `
              <b> ATENÇÃO: Utilize a mesma conta informada na etapa anterior, transfira o valor exato da compra! </b>
              <br>
              Você receberá o resumo detalhado do seu pedido juntamente com os dados bancários para transferência por e-mail.
              <br>
              Em caso de dúvidas sobre o pedido, por favor entre em contato conosco.
            `,
          },
          mobile: {
            title: 'Falta pouco, agora transfira o valor da sua compra',
            text: `
              <b> ATENÇÃO: Utilize a mesma conta informada na etapa anterior, transfira o valor exato da compra! </b>
              <br>
              Você receberá o resumo detalhado do seu pedido juntamente com os dados bancários para transferência por e-mail.
              <br>
              Em caso de dúvidas sobre o pedido, por favor entre em contato conosco.
            `,
            renewal: {
              title: 'Falta pouco, agora transfira o valor da sua compra',
              text: `
                <b> ATENÇÃO: Utilize a mesma conta informada na etapa anterior, transfira o valor exato da renovação! </b>
                <br>
                Você receberá o resumo detalhado da sua renovação juntamente com os dados bancários para transferência por e-mail.
                <br>
                Em caso de dúvidas sobre a renovação, por favor entre em contato conosco.
              `,
            },
            upsell: {
              title: 'Falta pouco, agora transfira o valor da sua compra',
              text: `
                <b> ATENÇÃO: Utilize a mesma conta informada na etapa anterior, transfira o valor exato da compra! </b>
                <br>
                Você receberá o resumo detalhado do seu pedido juntamente com os dados bancários para transferência por e-mail.
                <br>
                Em caso de dúvidas sobre o pedido, por favor entre em contato conosco.
              `,
            },
          }
        },
      },
    },
    spinpay: {
      policy: {
        title: 'Política de Privacidade da Spin Pay',
        text: `
          A Plataforma Spin Pay é uma infraestrutura de pagamento (“Plataforma”), por meio da qual a Spin Pay Serviços de Pagamentos Ltda. (“Spin Pay”, “nós” ou “nossos”), na qualidade de plataforma de pagamento, viabiliza transações de pagamento (“Serviços”) dos usuários (“Usuário”, “você” ou “seu”) nas compras de produtos em plataformas de comércio eletrônico. Para que a Plataforma possa adequadamente oferecer os Serviços é necessário que ela tenha acesso a determinadas informações sobre os Usuários, os “Dados”.
          <br><br>
          Não é possível realizar os Serviços sem ter acesso a esses Dados. Ou seja, o tratamento dos Dados é condição para que a Spin Pay consiga viabilizar as transações de pagamento.
          <br><br>
          O Usuário, ao tomar ciência e aceitar os termos desta política de privacidade (“Política”), concorda expressamente em fornecer apenas Dados verdadeiros, atuais e precisos e em não deturpar a sua identidade ou suas informações bancárias de qualquer forma no acesso e utilização da Plataforma e/ou na utilização dos Serviços.
          <br><br>
          Esta Política explica, de maneira simples, objetiva e transparente, quais Dados são coletados, usados e tratados pela Spin Pay e para quais finalidades, além de indicar com quem eles podem ser compartilhados.
          <br><br>
          SENDO UMA PLATAFORMA DE PAGAMENTO, NÓS COLETAMOS E PROCESSAMOS DIVERSOS TIPOS DE INFORMAÇÃO DOS USUÁRIOS DE NOSSA PLATAFORMA, COMO SERÁ EXPLICADO MAIS DETALHADAMENTE ABAIXO, E UTILIZAMOS ESSES DADOS PARA A PRESTAÇÃO DOS NOSSOS SERVIÇOS PARA GERAR A SOLICITAÇÃO DE PAGAMENTO À INSTITUIÇÃO FINANCEIRA OU À INSTITUIÇÃO DE PAGAMENTO, A FIM DE IDENTIFICAR E VALIDAR OS DADOS DO USUÁRIO E FINALIZAR A TRANSAÇÃO FINANCEIRA PARA A REALIZAÇÃO DE COMPRAS OU CONTRATAÇÕES DE SERVIÇOS. EM ALGUNS CASOS, TAMBÉM PODEREMOS COMPARTILHAR ALGUNS DE SEUS DADOS COM TERCEIROS, MAS TÃO SOMENTE NAS HIPÓTESES E FORMATO ABAIXO DESCRITOS.
          <br><br>
          Esta Política contém informações importantes sobre o tratamento de seus Dados organizadas nos seguintes itens:
          <br><br>
          1. Informações Gerais<br>
          2. Quais Dados coletamos e tratamos? Por quê?<br>
          3. Quando excluímos os Dados?<br>
          4. Quem mais terá acesso aos Dados? Por quê?<br>
          5. Como armazenamos e protegemos seus Dados?<br>
          6. Segurança<br>
          7. Alterações nesta Política<br>
          8. Como entrar em contato conosco?<br><br>
          <strong>1. Informações Gerais</strong><br>
          Somos comprometidos com a sua privacidade!
          <br><br>
          A Spin Pay protege os direitos de privacidade dos Usuários que utilizam a Plataforma, nos termos da legislação aplicável e de acordo com o disposto nesta Política.
          <br><br>
          Através desta Política, queremos dar a você transparência de quais Dados a seu respeito coletamos e utilizamos na Plataforma. Lembramos que a Plataforma presta Serviços para facilitar transações de pagamento. Por isso, a Plataforma precisa coletar, processar e utilizar determinadas informações para verificar que os Dados fornecidos por você são efetivamente seus e que nenhuma fraude está acontecendo com dados de terceiros. Além disso, precisamos coletar e tratar os Dados para o eventual cumprimento de obrigações legais, sobretudo, aquelas relacionadas à lavagem de dinheiro e anticorrupção.
          <br><br>
          Portanto, os Dados são fornecidos por você ou de outra forma coletados para que possamos:
          <br><br>
          realizar a autenticação de sua identidade;
          viabilizar a transação de pagamento;
          realizar eventuais auditorias.
          Se após a leitura desta Política você ainda tiver qualquer dúvida, ou, por qualquer razão precisar se comunicar conosco para assuntos envolvendo os seus Dados, por favor, entre em contato conosco pelo email oi@spinpay.com.br.
          <br><br>
          <strong>2. Quais Dados coletamos e tratamos? Por quê?</strong><br>
          Para utilizar os Serviços, o Usuário deve fornecer à Spin Pay dados necessários à sua identificação pela instituição financeira ou instituição de pagamento correspondente. A definição de quais dados são necessários para tal identificação é de responsabilidade da instituição financeira ou instituição de pagamento correspondente.
          <br><br>
          Além dos dados fornecidos pelo próprio Usuário para fins de identificação, conforme definido pela instituição financeira ou instituição de pagamento correspondente, a Spin Pay terá acesso a outros dados necessários para realizar a transação de pagamento: CPF, RG, endereço de e-mail, número de telefone, endereço e dados de conta bancária (instituição bancária, agência, número da conta, tipo de conta).
          <br><br>
          Para viabilizar a transação de pagamento entre a instituição financeira ou instituição de pagamento correspondente e a plataforma de comércio eletrônico, a Spin Pay recebe dados relacionados aos produtos adquiridos ou serviços contratados. Essas informações incluem data da transação, tipo de produto ou serviço e quantidade e valor da transação. A Spin Pay também pode receber das plataformas de comércio eletrônico informações relacionadas ao endereço de cobrança e entrega.
          <br><br>
          Nós nos reservamos no direito de acessar, ler, preservar e divulgar qualquer informação que acreditemos ser necessária para cumprir a lei ou ordem judicial ou de autoridade competente dentro dos termos da lei, a presente Política e quaisquer outros contratos ou termos com os quais os Usuários concordaram, bem como para proteger os direitos, propriedade ou segurança da Spin Pay, da Plataforma, seus funcionários, prestadores de serviço, Usuários ou terceiros.
          <br><br>
          <strong>3. Quando excluímos os Dados?</strong><br>
          Nós estruturamos a Plataforma e as nossas operações para que seus Dados sejam mantidos de maneira identificada somente pelo prazo e nas hipóteses previstas e autorizadas por lei. Ou seja, nós manteremos os Dados somente durante o período em que eles são necessários para as finalidades descritas acima, se formos obrigados por lei, ou se tivermos alguma outra razão legítima para mantê-los. Por isso, poderemos manter os seus dados pelo prazo estabelecido em lei, para que possamos, entre outras finalidades, cumprir obrigações legais, apresentar defesa em ações judiciais e/ou administrativas, combater fraude.
          <br><br>
          Caso sejam anonimizados, os Dados poderão ser mantidos indefinidamente pela Spin Pay.
          <br><br>
          <strong>4. Quem mais terá acesso aos Dados? Por quê?</strong><br>
          Podemos eventualmente compartilhar os Dados com terceiros, conforme identificado abaixo. Alguns desses terceiros podem estar localizados fora do Brasil. Se os seus Dados forem transferidos para outro país, nós adotaremos as medidas exigidas por lei, mas tenha em mente que, ao utilizar a Plataforma e nos fornecer seus Dados, eles poderão ser enviados a outros países.
          <br><br>
          Para que possamos prestar nossos Serviços, os Dados serão compartilhados com a instituição financeira ou de pagamento correspondente. Além disso, poderemos compartilhar os Dados com prestadores de serviço de infraestrutura e sistemas que viabilizam a operação da Spin Pay tão somente no escopo da prestação de tais serviços para a Spin Pay, como armazenamento em cloud, sem que esses prestadores de serviços utilizem os Dados para qualquer outra finalidade senão aquela necessária para a operação da Spin Pay
          <br><br>
          Poderemos compartilhar seus Dados, ainda, com autoridades judiciais, policiais ou governamentais para o eventual cumprimento de obrigação legal ou regulatória ou ordem judicial na medida do determinado por lei.
          <br><br>
          <strong>5. Como armazenamos e protegemos seus Dados?</strong><br>
          Nós armazenamos seus Dados de forma segura em data centers de terceiros localizados no Brasil e nos Estados Unidos, através de serviços de computação em nuvem. Antes de enviar seus Dados para armazenamento em outros países, nós adotamos as medidas exigidas por lei para assegurar que eles continuem protegidos.
          <br><br>
          Nós adotamos todas as medidas razoáveis para proteger os Dados de acessos não autorizados, destruição, perda, alteração, comunicação ou qualquer forma de tratamento inadequado ou ilícito. No entanto, nenhuma plataforma é completamente segura. Se você tiver qualquer preocupação ou suspeita de que seus Dados estão em risco, por favor, entre em contato conosco imediatamente.
          <br><br>
          <strong>6. Segurança</strong><br>
          Nós nos esforçaremos para proteger a privacidade dos nossos Usuários e outras informações que guardarmos em nossos registros. Contudo, nós não podemos garantir a mais completa segurança dos Usuários. O uso não autorizado, a falha do hardware ou software e outros fatores podem comprometer a segurança das informações do Usuário.
          <br><br>
          NESTE SENTIDO, A TRANSMISSÃO DE INFORMAÇÕES PELA INTERNET NÃO É COMPLETAMENTE SEGURA POR DIVERSOS FATORES, INCLUINDO FATORES DE REDE E DE OPERAÇÃO E A SPIN PAY NÃO TEM COMO GARANTIR A COMPLETA SEGURANÇA DOS DADOS TRANSMITIDOS PELOS USUÁRIOS À PLATAFORMA. APESAR DE FAZERMOS O NOSSO MELHOR PARA PROTEGER OS DADOS DOS USUÁRIOS, NÓS NÃO PODEMOS GARANTIR A SEGURANÇA DOS DADOS TRANSMITIDOS À PLATAFORMA. QUALQUER TRANSMISSÃO É DE EXCLUSIVA RESPONSABILIDADE DOS USUÁRIOS, OS QUAIS, AO CONCORDAR COM A PRESENTE POLÍTICA, RECONHECEM E ASSUMEM EXPRESSAMENTE TAL RESPONSABILIDADE.
          <br><br>
          <strong>7. Alterações nesta Política</strong><br>
          Nós poderemos alterar as disposições desta Política a nosso critério e a qualquer tempo. Sugerimos que o Usuário consulte este documento regularmente.
          <br><br>
          <strong>8. Como entrar em contato conosco?</strong><br>
          Você pode entrar em contato com a Spin Pay através: oi@spinpay.com.br.`
        ,
      },
    },
  },
};
